// extracted by mini-css-extract-plugin
export var card = "_qm-0";
export var content = "_qm-2";
export var details = "_qm-3";
export var icon = "_qm-1";
export var iconBlue = "_qm-5";
export var iconBrand = "_qm-4";
export var iconGrayBlue = "_qm-6";
export var iconGreen = "_qm-7";
export var iconIndigo = "_qm-8";
export var iconOrange = "_qm-9";
export var iconPurple = "_qm-a";
export var iconRed = "_qm-b";
export var iconWarning = "_qm-c";